import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IQuestionnairesPayload, QuestionnairesJson } from '../Questionnaires.ts';
import { QuestionnairesApi } from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetQuestionnairesByIdParam(id: number | null | undefined) {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.questionnaire, id],
        queryFn: async () => {
            const result: IQuestionnairesPayload = await QuestionnairesApi.getQuestionnairesById(String(id));
            return new QuestionnairesJson(result);
        },
        enabled: !!id,
    });
}
